module.exports = __webpack_public_path__ + "img/053.8478372c.png";